<template>
  <div>
    <div class="alert alert-danger alert-dismissable" role="alert" v-if="message">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <p class="mb-0">{{ message }}</p>
    </div>
    <div class="row push">
      <div class="col">
        <div class="block">
          <div class="block-header block-header-default">
            <h3 class="block-title">Link bewerken</h3>
          </div>
          <div class="block-content">
            <div class="form-group">
              <bs-select
                label="Startpagina"
                name="site_id"
                classname="js-select2"
                :options="[{ name: site.name, value: site.id }]"
                v-model="site.id"
                :disabled="true"
              ></bs-select>
            </div>
            <div class="form-group">
              <bs-select
                label="Pagina"
                name="page_id"
                classname="js-select2"
                :options="[{ name: link.page.title, value: link.page.id }]"
                :disabled="true"
                v-model="link.category.page.id"
              ></bs-select>
            </div>
            <div class="form-group">
              <bs-select
                label="Categorie"
                name="category_id"
                classname="js-select2"
                :options="categories"
                :disabled="categories.length === 0"
                v-model="link.category.id"
              ></bs-select>
            </div>
            <div class="form-group">
              <bs-input label="Linktekst" name="title" classname="js-maxlength" maxlength="42" :maxlengthShow="true" v-model="link.title"></bs-input>
            </div>
            <div class="form-group">
              <bs-input label="Url" name="url" v-model="link.url"></bs-input>
            </div>
            <div class="form-group">
              <bs-textarea
                label="Linkbeschrijving"
                rows="3"
                classname="js-maxlength"
                maxlength="150"
                :maxlengthShow="true"
                placeholder="Voer hier een beschrijving voor de link in"
                name="description"
                v-model="link.description"
              ></bs-textarea>
            </div>
            <div class="form-group">
              <bs-radio
                label="Type"
                :inline="true"
                name="follow"
                v-model="link.follow"
                :options="[
                  { name: 'Do follow', value: true },
                  { name: 'No follow', value: false },
                ]"
              ></bs-radio>
            </div>
            <div class="form-group">
              <bs-input
                type="date"
                label="Link is geactiveerd op"
                name="started_at"
                classname="js-flatpickr flatpickr-input"
                :disabled="true"
                v-model="link.started_at"
              ></bs-input>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-primary" v-on:click.prevent="submit">Wijzigen</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    site: {
      type: Object,
      required: true,
    },
    link: {
      type: Object,
      default: {},
    },
    page: {
      type: Object,
      default: {}
    },
    message: {
      type: String,
      default: null,
    },
    redirect: {
      type: String,
      default: 'links.index',
    }
  },
  data: () => {
    return {
      categories: [],
      errors: []
    };
  },
  created: function() {
    var self = this;
    this.categories = [];
    if (this.site.id && this.page) {
      this.categories = this.page.categories.map((item) => {
        return {
          value: item.id,
          name: self.$options.filters.capitalize(item.title),
        };
      });
    }
  },
  methods: {
    submit: function() {
      axios
        .put(route('links.update', this.site.id, this.link.id), {
          category_id: this.link.category.id,
          title: this.link.title,
          url: this.link.url,
          description: this.link.description,
          follow: this.link.follow === true,
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.errors = response.data.errors;
            this.message = response.data.message;
            if (response.data.success) {
              if (this.link.user_package_id) {
                window.location.href = route('packages.index');
              } else{
                window.location.href = route('links.index');
              }
            }
          }
        });
    },
  },
};
</script>
